module.exports = __webpack_public_path__ + "static/media/less.3c4cb525.png";